import * as React from 'react';

import { FAQContact } from './components/FAQContact';
import { FAQHeader } from './components/FAQHeader';
import { FAQWrapper } from './components/FAQWrapper';
import { IFAQPageReducer } from '../../interfaces/IFAQPage';
import { IFeatureFlag } from '../../interfaces/IFeatureFlag';
import { connect } from 'react-redux';

interface StateProps {
    faqPage: IFAQPageReducer;
    phoneNumber: string;
    contactPagePath: string;
    countryCode: string;
    contact: string;
    featureFlags: IFeatureFlag[];
}

interface DispatchProps {}

type Props = StateProps & DispatchProps;

export class FAQPageClass extends React.Component<Props, {}> {
    constructor(props) {
        super(props);
    }

    render() {
        const faq = this.props.faqPage.faq;
        const headline = this.props.faqPage.cmsData.headline;
        return (
            <div>
                <FAQHeader headline={headline} />
                <div className="faqPage--container">
                    <FAQContact
                        countryCode={this.props.countryCode}
                        phoneNumber={this.props.phoneNumber}
                        contactPageUrl={this.props?.contactPagePath}
                        contact={this.props?.contact}
                        featureFlags={this.props?.featureFlags}
                    />
                    <FAQWrapper faq={faq} />
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state: StateProps) => ({
    faqPage: state.faqPage,
    contactPagePath: (state as any)?.pageData?.brandConfig?.contactPagePath,
    phoneNumber: (state as any).pageData.brandConfig.phoneNumber,
    countryCode: (state as any).pageData.appConfig.countryCode,
    contact: (state as any)?.pageData?.brandConfig?.contactFormPagePath,
    featureFlags: (state as any)?.pageData?.featureFlags,
});

export const FAQPage = connect<StateProps, DispatchProps, any>(mapStateToProps, {})(FAQPageClass);
export default FAQPage;
